"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.roomEnrichment = exports.membersDifference = exports.isJoinedOrHoldMember = exports.default = void 0;
var _isNil = _interopRequireDefault(require("lodash/isNil"));
var _minBy2 = _interopRequireDefault(require("lodash/minBy"));
var _sortBy = _interopRequireDefault(require("lodash/sortBy"));
var _uniqBy = _interopRequireDefault(require("lodash/uniqBy"));
var _apis = require("../contacts/apis");
var _constants = require("../contacts/constants");
var _array = require("../../utils/array");
var _strings = require("../../utils/strings");
var _oldHttpClient = require("../../apiClient/oldHttpClient");
var _rooms = require("../../utils/rooms");
var _constants2 = require("./constants");
var _callbacks = _interopRequireDefault(require("../../callbacks"));
var _config = _interopRequireDefault(require("../../config"));
var _peerManager = _interopRequireDefault(require("../../utils/peerManager"));
var _streamManager = _interopRequireDefault(require("../../utils/streamManager"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var getStreamInfo = function getStreamInfo(_client, _entity) {
  var isSharingScreen = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return _objectSpread(_objectSpread({}, _streamManager.default.getStreamSummary({
    _client,
    _entity
  })), {}, {
    isSharingScreen
  });
};
var isJoinedOrHoldMember = exports.isJoinedOrHoldMember = _rooms.isJoinedOrHoldMember; // retro compat

var membersDifference = (prev, next) => {
  var nextMembers = next.members || [];
  var prevMembers = (prev === null || prev === void 0 ? void 0 : prev.members) || [];
  var prevMembersObj = (0, _array.convertArrayToObject)(prevMembers, 'id');
  var nextMembersObj = (0, _array.convertArrayToObject)(nextMembers, 'id');
  var result = {
    added: [],
    joined: [],
    left: [],
    kicked: [],
    membersByUserId: {},
    membersByClientId: {},
    isMyClientJoined: false,
    isMyUserJoined: false,
    isMyUserWaiting: false,
    membersJoinedCount: 0,
    isMembersChanged: false
  };
  Object.keys(nextMembersObj).forEach(id => {
    var _prevMembersObj$id;
    var {
      status,
      _client,
      _user
    } = nextMembersObj[id];
    var previousStatus = (_prevMembersObj$id = prevMembersObj[id]) === null || _prevMembersObj$id === void 0 ? void 0 : _prevMembersObj$id.status;
    var {
      LEFT,
      WAITING,
      KICKED
    } = _constants2.USER_IN_ROOM_STATUS;
    if (isJoinedOrHoldMember(status) && previousStatus !== status) {
      result.joined.push(_client);
    }
    if (status === LEFT && previousStatus !== status) result.left.push(_user);
    if (status === WAITING && previousStatus !== status) result.added.push(_user);
    if (status === KICKED && previousStatus !== status) result.kicked.push(_user);
  });

  // to be sure to handle left if member disappear from nextMembers
  Object.keys(prevMembersObj).forEach(id => {
    var {
      _user
    } = prevMembersObj[id];
    if (!nextMembersObj[id] && !result.left.includes(_user)) result.left.push(_user);
  });
  var _myClient;
  var _myUser;
  var allClientsJoined = [];
  var allUsersJoined = [];
  var allUsersWaiting = [];
  nextMembers.forEach(member => {
    var {
      isMe,
      _client,
      isMyUser,
      _user,
      status
    } = member;
    if (_user) result.membersByUserId[_user] = member;
    if (_client) result.membersByClientId[_client] = member;
    if (isJoinedOrHoldMember(status)) {
      if (_client) allClientsJoined.push(_client);
      allUsersJoined.push(_user);
    }
    if (status === _constants2.USER_IN_ROOM_STATUS.WAITING) {
      allUsersWaiting.push(_user);
    }
    if (isMe) _myClient = _client;
    if (isMyUser) _myUser = _user;
  });
  result.isMyClientJoined = allClientsJoined.includes(_myClient);
  result.isMyUserJoined = allUsersJoined.includes(_myUser);
  result.isMyUserWaiting = allUsersWaiting.includes(_myUser);
  result.membersJoinedCount = allUsersJoined.length;
  result.isMembersChanged = !!(result.added.length + result.joined.length + result.left.length + result.kicked.length);
  return result;
};
exports.membersDifference = membersDifference;
var isCallerContact = {};
var fullnameByPhonenumber = {};
var avatarByPhonenumber = {};
var memberEnrichment = (_room, _myUser, _myClient) => member => {
  var isMe = _myClient === member._client;
  var {
    state: peerState,
    stateAt: peerStateAt,
    quality: peerQuality
  } = _peerManager.default.getStateInfos({
    _entity: _room,
    _client: member._client
  }) || {};
  var isJoined = isJoinedOrHoldMember(member.status) || undefined;

  // member.phonenumber should be removed in favor of member.displayablePhonenumber
  // when mobile app will be fully updated to this min BC version
  // after that, backend can remove safelly phonenumber from member object
  // (or replace value with displayablePhonenumber)
  // reminder :
  // - member.phonenumber is the phone number with prefix
  // - member.displayablePhonenumber is the phone number without prefix
  // https://github.com/amplement/support/issues/428
  var phonenumber = member.displayablePhonenumber || member.phonenumber || '';
  var fullname = phonenumber && !member.firstname && !member.lastname ? fullnameByPhonenumber[phonenumber] : (0, _strings.getFullname)(member);
  var stream = getStreamInfo(member._client, _room, member.isSharingScreen);
  return _objectSpread(_objectSpread({}, member), {}, {
    avatarUri: avatarByPhonenumber[phonenumber] || member.avatarUri,
    id: "".concat(member._user, "_").concat(member._client),
    isJoined,
    // used only to sortBy isJoined, Should be removed after sort
    firstname: (0, _strings.getFullname)({
      firstname: member.firstname,
      lastname: undefined
    }),
    lastname: (0, _strings.getFullname)({
      firstname: member.lastname,
      lastname: undefined
    }),
    phonenumber,
    // due to mergeEntities, need to define a value to overwrite focusOn in redux
    title: phonenumber ? null : member.title || null,
    fullname,
    isMe,
    isMyUser: _myUser === member._user,
    stream,
    peerState,
    peerStateAt,
    peerQuality
  });
};
var contactsEnrichment = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(function* (members) {
    // looking into the contacts of the phone if !fullname and phonenumber
    if (_callbacks.default.isExist('findInContacts')) {
      return Promise.all(members.map( /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(function* (member) {
          if (!member) return;
          var {
            displayablePhonenumber: phonenumber,
            fullname,
            avatarUri
          } = member;
          if (phonenumber && !fullname && !fullnameByPhonenumber[phonenumber]) {
            var _contacts$;
            var contacts = yield _callbacks.default.get('findInContacts')(phonenumber, {
              searchByName: false
            });
            if (contacts !== null && contacts !== void 0 && (_contacts$ = contacts[0]) !== null && _contacts$ !== void 0 && _contacts$.fullname) {
              var _contacts$2, _contacts$3;
              fullnameByPhonenumber[phonenumber] = contacts === null || contacts === void 0 || (_contacts$2 = contacts[0]) === null || _contacts$2 === void 0 ? void 0 : _contacts$2.fullname;
              fullname = contacts === null || contacts === void 0 || (_contacts$3 = contacts[0]) === null || _contacts$3 === void 0 ? void 0 : _contacts$3.fullname;
              if (!avatarUri) {
                var _contacts$4, _contacts$5;
                avatarByPhonenumber[phonenumber] = contacts === null || contacts === void 0 || (_contacts$4 = contacts[0]) === null || _contacts$4 === void 0 ? void 0 : _contacts$4.avatarUri;
                avatarUri = contacts === null || contacts === void 0 || (_contacts$5 = contacts[0]) === null || _contacts$5 === void 0 ? void 0 : _contacts$5.avatarUri;
              }
            } else {
              // save that your already done the search , and it was unsuccessful
              fullnameByPhonenumber[phonenumber] = phonenumber;
            }
          }
          return member;
        });
        return function (_x2) {
          return _ref2.apply(this, arguments);
        };
      }()));
    }
    return Promise.resolve(members);
  });
  return function contactsEnrichment(_x) {
    return _ref.apply(this, arguments);
  };
}();
var roomEnrichment = exports.roomEnrichment = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator(function* (_ref3) {
    var _room$members, _minBy, _config$webRTC, _newRoom$features;
    var {
      room,
      _client: _myClient,
      _user,
      searchContact = true
    } = _ref3;
    if (!room.features) {
      room.features = {
        audio: true,
        hold: false,
        video: true,
        dtmf: false,
        persistence: true,
        public: true,
        screenSharing: true,
        editMembers: true,
        transfers: undefined,
        // tag to be able to transfer this room to other room with this same tag
        transferToPhonenumber: false,
        // allow the client to transfer the call to a PhoneAccount
        transferToSipUser: false,
        // allow the client to transfer to a relation with a sip account
        transferToUser: false // allow the client to transfer to a relation
      };
    }

    var enrichedMembers = ((_room$members = room.members) === null || _room$members === void 0 ? void 0 : _room$members.map(memberEnrichment(room.id, _user, _myClient))) || [];
    var myMember = enrichedMembers.find(x => !!x.isMe);
    var otherMembers = enrichedMembers.filter(x => !x.isMe);
    var caller = enrichedMembers.find(_ref5 => {
      var {
        isCaller
      } = _ref5;
      return isCaller;
    });
    var isHold = (myMember === null || myMember === void 0 ? void 0 : myMember.status) === _constants2.USER_IN_ROOM_STATUS.HOLD;
    var inProgress = otherMembers === null || otherMembers === void 0 ? void 0 : otherMembers.some(x => !!x.isJoined);
    var searchInPhoneContacts = enrichedMembers.some(m => !m.isMe && m.phonenumber && !m.firstname && !m.lastname);
    var firstJoin = (_minBy = (0, _minBy2.default)(enrichedMembers, m => m.isMe ? undefined : new Date(m.joinedAt))) === null || _minBy === void 0 ? void 0 : _minBy.joinedAt;
    var orderedMembers = (0, _uniqBy.default)((0, _sortBy.default)(enrichedMembers, ['isJoined', 'invitedAt', 'fullname']), a => a.id);
    var duration = firstJoin ? Date.now() - new Date(firstJoin).getTime() : 0;
    var newRoom = _objectSpread(_objectSpread({}, room), {}, {
      isHold,
      inProgress: !!inProgress,
      myStream: myMember === null || myMember === void 0 ? void 0 : myMember.stream,
      isHDEnabled: (_config$webRTC = _config.default.webRTC) === null || _config$webRTC === void 0 ? void 0 : _config$webRTC.HDEnabled,
      duration,
      members: orderedMembers,
      caller
    });
    newRoom.members.forEach(el => {
      delete el.isJoined;
      return el;
    });

    // Check how many people are in the room and set the displayMode of the room accordingly.
    var totalConnectedMembersExceptMyself = otherMembers.filter(_ref6 => {
      var {
        status
      } = _ref6;
      return isJoinedOrHoldMember(status);
    }).length;
    if (totalConnectedMembersExceptMyself <= 1) {
      // Handle the case if everyone leaves the room except one person
      newRoom.displayMode = _constants2.ROOM_DISPLAY_MODE.FULL_SCREEN;
    } else if (totalConnectedMembersExceptMyself >= 2 && !newRoom.forcedDisplayMode) {
      // Switch to grid mode when someone arrives in the room and no focus is forced
      newRoom.displayMode = _constants2.ROOM_DISPLAY_MODE.GRID;
    }
    if (newRoom.displayMode === _constants2.ROOM_DISPLAY_MODE.FULL_SCREEN) {
      var _newRoom$focusOn;
      // Handle the case where I want to focus the ringing person when I make a call in a 1 to 1 but do not focus
      // anyone when I join a room where no one is present.
      // (a 1 to 1 room with someone that is not ringing nor has joined does not exist and the room will exit (except if is the administrator of the room)

      if (totalConnectedMembersExceptMyself === 0 && ((_newRoom$focusOn = newRoom.focusOn) === null || _newRoom$focusOn === void 0 ? void 0 : _newRoom$focusOn._client) !== _myClient) {
        newRoom.focusOn = null;
      } else if (totalConnectedMembersExceptMyself >= 1 || enrichedMembers.length === 2) {
        // If a client is already focus check if he is always into the room
        if (newRoom.focusOn) {
          newRoom.focusOn = enrichedMembers.find(_ref7 => {
            var _newRoom$focusOn2;
            var {
              _client,
              status
            } = _ref7;
            return _client === (newRoom === null || newRoom === void 0 || (_newRoom$focusOn2 = newRoom.focusOn) === null || _newRoom$focusOn2 === void 0 ? void 0 : _newRoom$focusOn2._client) && isJoinedOrHoldMember(status);
          });
        }

        // Look into the streamManager for a client to focus on (gave focusOn priority to client choice)
        if (!newRoom.focusOn) {
          var _focusClient = _streamManager.default.getFocus(room.id);
          if (_focusClient) {
            newRoom.focusOn = enrichedMembers.find(member => _focusClient === member._client);
          }
        }

        // Fallback #1 try to find another user than me who has joined
        // Fallback #2 back request to focus on myself
        // Fallback #3 focus nobody (no room update with the _client associated to the PC_REQUEST)
        if (!newRoom.focusOn) {
          newRoom.focusOn = enrichedMembers.find(_ref8 => {
            var {
              isMe,
              isMyUser,
              status
            } = _ref8;
            return !isMe && !isMyUser && isJoinedOrHoldMember(status);
          }) || myMember || null;
        }
      }
    } else {
      newRoom.focusOn = null;
    }
    if (typeof (newRoom === null || newRoom === void 0 || (_newRoom$features = newRoom.features) === null || _newRoom$features === void 0 ? void 0 : _newRoom$features.transfers) === 'string') {
      newRoom.features.transfers = newRoom.features.transfers.toLowerCase();
    }

    // check if token is set to avoid searching contact on the web because you can reach a room without be logged (guest or sign in)
    if (newRoom.caller && !newRoom.caller.isGuest && searchContact && (0, _oldHttpClient.isAxiosTokenSet)()) {
      var callerId = newRoom.caller._user;
      if (!newRoom.caller.isMyUser) {
        newRoom.features.displayReminder = true;
        if ((0, _isNil.default)(isCallerContact[callerId])) {
          try {
            var _response$data;
            var response = yield (0, _apis.$searchContactsById)(callerId);
            isCallerContact[callerId] = (response === null || response === void 0 || (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.contactStatus) === _constants.CONTACT_STATUS.ACCEPTED;
          } catch (e) {
            isCallerContact[callerId] = false;
          }
        }
        newRoom.features.displayFastReply = isCallerContact[callerId];
      }
    }

    // looking into the contacts of the phone if !fullname and phonenumber
    if (searchContact && searchInPhoneContacts && _callbacks.default.isExist('findInContacts')) {
      newRoom.members = yield contactsEnrichment(newRoom.members);
    }
    return newRoom;
  });
  return function roomEnrichment(_x3) {
    return _ref4.apply(this, arguments);
  };
}();
var _default = exports.default = {
  roomEnrichment,
  membersDifference,
  isJoinedOrHoldMember
};